import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import TickMark from "../../../assets/images/signup_images/TickMark.svg";
import UserTour from "../../components/UserTour/UserTour";
import { accountSetupStep2 } from "../../components/UserTour/Data/DiscoverSteps";
// * Import custom components
import MapComponent from "../../components/WorldMap/MapComponent";

// * Import kits
import Typography from "../../kit/Typography";
import Button from "../../kit/Button";

// * Import data & utils
import {
  northAmericanCountries,
  ASEANCountries,
  LATAMCountries,
  centralAndEasternEuropeCountriesList,
  affricanCountries,
  westernSuropeCountries,
} from "../../../assets/data/accountSetupData";

// * Import actions
import {
  accountSetupLocation,
  accountSetupRemoveLocation,
} from "../../redux/slice/accountSetupSlice";

// * Import styles
import { accountSetupStyles } from "../../theme/style";

// # Component
const LocationContent = ({ templateData }) => {
  // # Hooks
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.accountSetup.geography);
  const [countries, setCountries] = useState([]);
  const theme = useTheme();
  const classes = accountSetupStyles(theme);
  const locationList = templateData?.options?.map((elem) => elem.name);
  const userJourney = useSelector((state) => state.auth.userJourney);
  let newUserPageFlag =
    userJourney?.isNewUser &&
    userJourney?.pagesToShow?.["accountSetupLocation"];
  useEffect(() => {
    if (locations) {
      let allCountries = [];
      for (const location of locations) {
        if (location === "North America") {
          allCountries = [...allCountries, ...northAmericanCountries];
        }
        if (location === "APAC") {
          allCountries = [...allCountries, ...ASEANCountries];
        }
        if (location === "Western Europe") {
          allCountries = [...allCountries, ...westernSuropeCountries];
        }
        if (location === "Central and Eastern Europe") {
          allCountries = [
            ...allCountries,
            ...centralAndEasternEuropeCountriesList,
          ];
        }
        if (location === "LATAM") {
          allCountries = [...allCountries, ...LATAMCountries];
        }
        if (location === "Africa") {
          allCountries = [...allCountries, ...affricanCountries];
        }
      }
      setCountries(allCountries);
    }
  }, [locations]);

  // # Handlers
  const handleDivision = (val) => {
    if (locations?.includes(val)) {
      dispatch(accountSetupRemoveLocation(val));
    } else {
      dispatch(accountSetupLocation([...locations, val]));
    }
  };

  const cardStyling = {
    fontStyle: "normal",
    fontWeight: theme.fontWeight[700],
    fontSize: theme.size[14],
    lineHeight: theme.size[23],
    display: "flex",
    alignItems: "left",
    textAlign: "left",
    boxShadow: theme.boxShadow,
    borderRadius: theme.size[4],
    height: theme.size[35],
    textTransform: "none",
    border: false
      ? "1px solid #463f50 !important"
      : `${theme.size[1]} solid ${theme.palette.optionsCard.border} !important`,
    justifyContent: "space-between",
    padding: "0 20px",
    width: "280px",
    "&:hover": {
      border: `${theme.size[1]} solid ${theme.palette.optionsCard.hoverBackground} !important`,
      color: theme.palette.optionsCard.hoverText,
      background: theme.palette.optionsCard.hoverBackground,
    },
  };

  // # JSX
  return (
    <>
      <UserTour
        steps={accountSetupStep2}
        isOpen={userJourney?.showJourney || newUserPageFlag}
        page={"accountSetupLocation"}
        newUserPageFlag={newUserPageFlag}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Stack>
          <Typography
            sx={{
              maxWidth: "700px",
              textTransform: "uppercase",
              margin: theme.size[10],
              color: theme.palette.cards.heading,
            }}
          >
            {templateData?.Description}
          </Typography>
        </Stack>
        <div style={{ height: "calc(100vh - 350px)", overflow: "auto" }}>
          <Stack style={{ width: "100%" }}>
            <MapComponent divisions={countries} />
          </Stack>
          <div style={{ display: "flex" }}>
            <Stack
              id="locationContent"
              display="grid"
              gridTemplateColumns="repeat(2, 1fr)"
              alignItems="center"
              justifyContent="center"
              flexWrap="wrap"
              gap={theme.size[14]}
              zIndex={1000}
              sx={{ overflowY: "auto" }}
            >
              {locationList.length &&
                locationList.map((item) => (
                  <Button
                    disableRipple
                    key={item}
                    className={
                      locations?.includes(item)
                        ? classes.geoBtnSelected
                        : classes.geoBtnUnselected
                    }
                    sx={{ ...cardStyling }}
                    onClick={() => handleDivision(item)}
                  >
                    {item}
                    <Stack
                      component="img"
                      alt="Logo"
                      sx={{
                        width: "6%",
                        display: locations?.includes(item) ? "block" : "none",
                      }}
                      src={TickMark}
                    />
                  </Button>
                ))}
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

// # Exports
export default LocationContent;
